import { ApiStatus } from '../../types';
import { GenericBladeInitParam, GenericBladeType } from '../genericBlade';
import {
    otherIncomeDefaultAEM,
    OtherIncomeEdit,
    OtherIncomeEndpoints,
    OtherIncomeState,
} from './otherIncomeTypes';

export const defaultOtherIncomeDetails: Record<number, OtherIncomeEdit> = {
    1: {
        incomeId: 47516829,
        incomeTypeId: '73-5',
        frequency: 'Monthly',
        amount: 201.0,
        description: 'Rental Income',
        incomeTypeDescription: 'Rental Income',
        netAmount: undefined,
        isEditMode: false,
    },
    2: {
        incomeId: 47817198,
        incomeTypeId: '73-3',
        frequency: 'Monthly',
        amount: 0.0,
        description: 'Part-time uber staff',
        incomeTypeDescription: 'Part-time uber staff',
        netAmount: undefined,
        isEditMode: false,
    },
};

export const otherIncomeApiEndpointsDefault: OtherIncomeEndpoints = {
    getOtherIncomeUrl: '/getOtherIncomeUrl',
    addDirectIncomeUrl: '/addDirectIncomeUrl',
    addIndirectIncomeUrl: '/addIndirectIncomeUrl',
    updateDirectIncomeUrl: '/updateDirectIncomeUrl/{incomeId}',
    updateIndirectIncomeUrl: '/updateIndirectIncomeUrl/{incomeId}',
    deleteDirectIncomeUrl: '/deleteDirectIncomeUrl/{incomeId}',
    deleteIndirectIncomeUrl: '/deleteIndirectIncomeUrl/{incomeId}',
};

export const initialOtherIncomeState: OtherIncomeState = {
    apiStatus: ApiStatus.Idle,
    apiEndpoints: otherIncomeApiEndpointsDefault,
    content: otherIncomeDefaultAEM,
    incomeDetails: [],
    incomeApiStatus: ApiStatus.Idle,
    lastVisitedItem: {
        id: null,
        mode: null,
        isSaved: false,
    },
    isAddMode: false,
};

export const noOtherIncomePreloadState: GenericBladeInitParam = {
    id: 'income-no-other',
    genericBladeType: GenericBladeType.confirm,
    content: {
        heading: '{heading placeholder}',
        description: '{description placeholder}',
        confirmButtonText: '{confirmButtonText}',
        cancelButtonText: '{cancelButtonText}',
    },
};
